import {
  CHATBOT_INTERACT,
  CHATBOT_INTERACT_SUCCESS,
  CHATBOT_INTERACT_FAILURE,
  CHATBOT_VOICETOTEXT,
  CHATBOT_VOICETOTEXT_SUCCESS,
  CHATBOT_VOICETOTEXT_FAILURE,
} from "./actionType";

//CHATBOT_INTERACT
export const chatbotInteract = (payload) => ({
  type: CHATBOT_INTERACT,
  payload,
});
export const chatbotInteractSuccess = (payload) => ({
  type: CHATBOT_INTERACT_SUCCESS,
  payload,
});
export const chatbotInteractFailure = (payload) => ({
  type: CHATBOT_INTERACT_FAILURE,
  payload,
});

//CHATBOT_VOICETOTEXT
export const chatbotVoiceToText = (payload) => ({
  type: CHATBOT_VOICETOTEXT,
  payload,
});
export const chatbotVoiceToTextSuccess = (payload) => ({
  type: CHATBOT_VOICETOTEXT_SUCCESS,
  payload,
});
export const chatbotVoiceToTextFailure = (payload) => ({
  type: CHATBOT_VOICETOTEXT_FAILURE,
  payload,
});
